export class FiltroAluno {
	
	beneficiario: string;
	mae: string;
	cpf: string;
	dataInicioEntradaInstituicao: Date;
	dataFimEntradaInstituicao: Date;
	ativo: string;
}